var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown16 = function SvgArrowDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.073 10.78 1.78 5.487l.707-.707 5.293 5.293a.5.5 0 0 0 .707 0L13.78 4.78l.707.707-5.292 5.293a1.5 1.5 0 0 1-2.122 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown16;